import ky from 'ky'

/**
 * Call this function with a URL and optional filename to download the resource
 * at that URL. The filename will be derived from the URL if you don't provide
 * one
 */
export const download = async (url: string, filename?: string) => {
    const blob = await ky.get(url, {timeout: 30000}).blob()
    const windowUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')

    a.href = windowUrl
    a.download = filename || url.substring(url.lastIndexOf('/') + 1)
    a.click()
}
